<template>
  <div>
    <Modal v-model="modal" :title="!tagWarningForm.id ? $t('tag.monitoring.addTagAlarm') : $t('tag.monitoring.editTagAlarm')" :loading="loading" :mask-closable="false"
           width="600px" :styles="{top:'65px'}">
      <Form ref="tagWarningForm" :model="tagWarningForm" :label-width="100" :rules="ruleValidate">
        <Row style="margin-bottom: 20px;">
          <Col span="24">
            <Card >
              <!-- 云平台 -->
              <Row style="margin-top: 15px;">
                <FormItem :label="$t('tag.monitoring.cloudPlatform')" prop="cloudType">
                  <Select v-model="tagWarningForm.cloudType" filterable  @on-change="changeCloudTypeOrCompany()" :transfer="true" style="width:300px;" :placeholder="$t('tag.monitoring.cloudPlatform')">
                    <Option :value="item.id" v-for="item in cloudTypeList" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Row>
              <div v-if="this.company == 1">
                <Row>
                  <!-- 公司 -->
                  <FormItem :label="$t('tag.monitoring.company')" prop="companyId">
                    <Select v-model="tagWarningForm.companyId" filterable @on-change="changeCloudTypeOrCompany()" :transfer="true" style="width:300px;" :placeholder="$t('tag.monitoring.company')">
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{ item.companyName }}</Option>
                    </Select>
                  </FormItem>
                </Row>
              </div>
              <Row>
                <!-- 账户 -->
                <FormItem :label="$t('tag.monitoring.accountField')" prop="accountId">
                  <Select v-model="tagWarningForm.accountId" filterable style="width:300px;" @on-change="getRegionList()"  :transfer="true" :placeholder="$t('tag.monitoring.accountField')">
                    <Option :value="item.id" v-for="item in accountList" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Row>
              <Row>
                <!-- 区域 -->
                <FormItem :label="$t('tag.monitoring.region')" prop="region">
                  <Select v-model="tagWarningForm.region" filterable style="width:300px;"  :transfer="true" :placeholder="$t('tag.monitoring.region')">
                    <Option :value="item.name" v-for="item in regionList" :key="item.name">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Row>
              <Row>
                <!-- 规则名称 -->
                <FormItem :label="$t('tag.monitoring.ruleName')" prop="ruleName" >
                  <Input v-model="tagWarningForm.ruleName" :placeholder="$t('tag.monitoring.ruleName')" style="width:300px;"></Input>
                </FormItem>
              </Row>
              <Row>
                <!-- 资源类型 -->
                <FormItem :label="$t('tag.monitoring.resourceType')" prop="resourceType">
                  <Select v-model="tagWarningForm.resourceType" style="width:300px;" :transfer="true">
                    <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Row>
              <Row>
                <!-- 规则描述 -->
                <FormItem :label="$t('tag.monitoring.ruleDescription')">
                  <Row :gutter="6">
                    <!-- KEV -->
                    <Col span="5">
                      <FormItem prop="key">
                        <Input v-model="tagWarningForm.key" :placeholder="$t('tag.monitoring.key')" ></Input>
                      </FormItem>
                    </Col>
                    <!-- 关系 -->
                    <Col span="6">
                      <FormItem prop="relation">
                        <Select v-model="tagWarningForm.relation" :placeholder="$t('tag.monitoring.relation')">
                          <Option :value="item.id" v-for="item in relationList" v-bind:key="item.id">
                            {{ item.name }}
                          </Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <!-- Value -->
                    <Col span="5">
                      <FormItem prop="value">
                        <Input v-model="tagWarningForm.value" :placeholder="$t('tag.monitoring.value')" ></Input>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>
              </Row>
              <Row>
                <!-- 通知对象 -->
                <FormItem :label="$t('tag.monitoring.notificationTarget')" prop="contact">
                  <Select v-model="tagWarningForm.contact" multiple style="width:300px;" :placeholder="$t('tag.monitoring.contact')">
                    <Option v-for="item in contactList" :value="item.email" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="" prop="">
                  <span>{{ $t('tag.monitoring.autoExecuteTip') }}</span>
                </FormItem>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button size="large" @click="cancel('tagWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
        <Button type="primary" size="large" @click="ok('tagWarningForm')" :loading="loading">
          {{ !tagWarningForm.id ? $t('alarms.common.add') : $t('alarms.common.edit') }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {getCookie} from '../../../../utils/cookieUtil.js'

  var tableTagMonitoringVue = {}
  export default {
    inject: ['reload'],
    components: {
    },
    data() {
      return {
        company: getCookie(global.companyId),
        loading: false,
        modal: false,
        isAddOrEdit: true,
        cloudTypeList: [],
        companyList: [],
        accountList: [],
        regionList: [],
        resourceTypeList: [],
        contactList: [],
        relationList: [],
        tagWarningForm: {
          ruleName: '',
          cloudType: '',
          companyId: '',
          accountId: '',
          region: '',
          resourceType: '',
          key: '',
          value: '',
          relation: '',
          contact: ''
        },
        ruleValidate: {
          ruleName: [
            {required: true, message: this.$t('tag.monitoring.pleaseInputRuleName'), trigger: 'blur'}
          ],
          cloudType: [
            {required: true, message: this.$t('tag.monitoring.pleaseSelectCloudPlatform'), trigger: 'change', type: 'number'}
          ],
          companyId: [
            {required: true, message: this.$t('tag.monitoring.pleaseSelectCompany'), trigger: 'change', type: 'number'}
          ],
          accountId: [
            {required: true, message: this.$t('tag.monitoring.pleaseSelectAccountName'), trigger: 'change', type: 'number'}
          ],
          resourceType: [
            {required: true, message: this.$t('tag.monitoring.pleaseSelectResourceType'), trigger: 'change', type: 'number'}
          ],
          region: [
            {required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change'}
          ],
          relation: [
            {required: true, message: this.$t('tag.monitoring.pleaseSelectRelation'), trigger: 'change', type: 'number'}
          ]
        }
      }
    },

    beforeCreate: function () {
      tableTagMonitoringVue = this
    },
    methods: {
      init: function (row) {
        // 查询云平台
        this.getAccountType();
        // 查询公司
        this.getCompanyList();
        // 查询关系
        this.getRelationList();
        this.$nextTick(() => {
          // 重置表单
          this.$refs['tagWarningForm'].resetFields();
          if (row !== null && row !== undefined && this.StringUtils.isNotEmpty(row.id)) {
            // 编辑
            this.isEdit = true;
            this.tagWarningForm.id = row.id;
            this.tagWarningForm.cloudType = row.cloudType;
            this.tagWarningForm.companyId = row.companyId;
            this.tagWarningForm.accountId = row.accountId;
            this.tagWarningForm.ruleName = row.ruleName;
            // 查询区域
            this.getRegionList();
            this.tagWarningForm.region = row.region;
            // 查询资源类型
            this.getResourceTypeList();
            this.tagWarningForm.resourceType = row.resourceType;
            this.tagWarningForm.key = row.key;
            // 查询关系
            this.tagWarningForm.relation = row.relation;
            this.tagWarningForm.value = row.value;
            this.tagWarningForm.contact = row.contactList;
          } else {
            // 添加
            this.isEdit = false;
          }
        })
        this.modal = true;
      },

      /**************************************  查询  **************************************/
      //查询云平台
      getAccountType: function () {
        this.$api.account.queryCloudPlatformsByCurrentUser("userName", getCookie(global.cookieName))
          .then(res => {
              this.cloudTypeList = res.data;
          })
      },
      // 公司
      getCompanyList: function () {
        this.$api.user.listRegisterInformation()
          .then(res => {
            // 获取公司列表数据
            this.companyList = res.data.companies;
            // 查询的当前公司下的账号列表
            this.getAccountList();
            // 查询联系人
            this.getContactList();
          })
      },
      // 切换云平台/公司
      changeCloudTypeOrCompany(){
          // 查询账号
          this.getAccountList();
          // 查询联系人
          this.getContactList();
          // 查询资源类型
          this.getResourceTypeList();
      },
      // 查询账户
      getAccountList: function () {
        this.tagWarningForm.accountId = '';
        this.accountList = [];
        if (this.StringUtils.isNotEmpty(this.tagWarningForm.cloudType) && this.StringUtils.isNotEmpty(this.tagWarningForm.companyId)){
          let companyId = this.company == 1 ? this.tagWarningForm.companyId : this.company;
          this.$api.account.inquireAccount({
              "type" : this.tagWarningForm.cloudType,
              "companyId" : companyId,
            })
            .then(res => {
                this.accountList = res.data;
            })
        }
      },
      // 查询区域
      getRegionList(){
        this.tagWarningForm.region = '';
        this.regionList = [];
        if (this.StringUtils.isNotEmpty(this.tagWarningForm.accountId)) {
          this.$api.account.queryAccountRegions("accountId", this.tagWarningForm.accountId)
            .then(res => {
              this.regionList = res.data;
            });
        }
      },
      // 查询资源类型
      getResourceTypeList(){
        if (this.StringUtils.isNotEmpty(this.tagWarningForm.cloudType)) {
          this.$api.resourceTagWarning.inquireResourceType("cloudType", this.tagWarningForm.cloudType)
            .then(res => {
              this.resourceTypeList = res.data;
            });
        }
      },
      // 查询关系
      getRelationList: function () {
        this.$api.resourceTagWarning.inquireRelation()
          .then(res => {
            this.relationList = res.data;
          });
      },
      // 获取联系人
      getContactList: function () {
        if (this.StringUtils.isNotEmpty(this.tagWarningForm.companyId)) {
          this.$api.contact.selectContactListByCompanyId("companyId",this.tagWarningForm.companyId)
            .then(res => {
              this.contactList = res.data;
            });
        }
      },
      // 创建报警
      /**********************************************************************************/
      ok: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            let resourceTagWarningDTO = {
              "cloudType": this.tagWarningForm.cloudType,
              "companyId": this.tagWarningForm.companyId,
              "accountId": this.tagWarningForm.accountId,
              "region": this.tagWarningForm.region,
              "ruleName": this.tagWarningForm.ruleName,
              "resourceType": this.tagWarningForm.resourceType,
              "key": this.tagWarningForm.key,
              "relation": this.tagWarningForm.relation,
              "value": this.tagWarningForm.value,
              "contactList": this.tagWarningForm.contact,
            };
            if (this.tagWarningForm.id > 0) {
              resourceTagWarningDTO.id = this.tagWarningForm.id;
              // 编辑告警
              this.loading = true;
              this.$api.resourceTagWarning.update(resourceTagWarningDTO)
                .then(res => {
                  this.data = res.data;
                  setTimeout(() => {
                    this.reload();
                    this.$refs[name].resetFields();
                    this.loading = false;
                    this.$nextTick(() => {
                      this.loading = true;
                    });
                    this.$Message.success(this.$t('common.editSuccess'));
                    this.loading = false;
                    this.modal = false;
                    this.isAddOrEdit = true;
                  }, 1000);
                })
            } else {
              // 添加告警
              this.loading = true;
              this.$api.resourceTagWarning.create(resourceTagWarningDTO)
                .then(res => {
                  this.data = res.data;
                  setTimeout(() => {
                    this.reload();
                    this.$refs[name].resetFields();
                    this.loading = false;
                    this.$nextTick(() => {
                      this.loading = true;
                    });
                    this.$Message.success(this.$t('common.addSuccess'));
                    this.loading = false;
                    this.modal = false;
                    this.isAddOrEdit = true;
                  }, 1000);
                })
            }

          } else {
            //解决I-View 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            if (this.tagWarningForm.id > 0) {
              this.$Message.error(this.$t('common.editFail'));
            } else {
              this.$Message.error(this.$t('common.addFail'));
            }
          }
        });
      },
      // 取消
      cancel: function (name) {
        this.isAddOrEdit = true;
        this.$nextTick(() => {
          this.$refs[name].resetFields();
        });
        this.modal = false;

      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_monitoring/AddOrUpdateTagMonitoring.vue